

























import { BrandConfigKeys } from "@/data/constants";
import { IState } from "@/store";
import { Vue, Component } from "vue-property-decorator";
import { mapState } from "vuex";

@Component({
  components: {
    "upgrade-control": () =>
      import("@/skeleton/admin/loggedIn/contentHeaderUpgradeControl.vue"),
    "first-steps-control": () =>
      import("@/skeleton/admin/loggedIn/contentHeaderFirstStepsControl.vue"),
    "docs-control": () =>
      import("@/skeleton/admin/loggedIn/contentHeaderDocsControl.vue"),
    "quick-actions": () =>
      import("@/skeleton/admin/loggedIn/contentHeaderQuickActions.vue"),
    "verify-pin": () =>
      import("@/skeleton/admin/loggedIn/contentHeaderVerifyPin.vue")
  },
  computed: {
    ...mapState({
      isSupportPinEnabled(state: IState) {
        return !!state.brand.config[BrandConfigKeys.SUPPORT_PIN_ENABLED];
      }
    })
  }
})
export default class AdminContentHeader extends Vue {
  // Data

  public readonly isSupportPinEnabled!: boolean;

  // Computed
  public get previousRoute() {
    return this.$store.getters["ui/previousRoute"];
  }
}
